import { Http } from '@/lib/http';

export class DelinquencyGraceDaysService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/grace-days/';
  }

  /**
   * FACTOR SETUP ACTIONS
   */

  getFactorSetups(params) {
    return this.httpClient().get(`${this.endpoint}factor-setup/paginated`, { params });
  }

  /**
   * Creates the factor setup
   * @param {Object} payload - The payload to create the factor setup.
   */
  createFactorSetup(payload) {
    return this.httpClient().post(`${this.endpoint}factor-setup/`, payload);
  }

  /**
   * Updates the factor setup
   * @param {String} id - The id of the factor setup
   * @param {Object} payload - The payload to update the factor setup.
   */
  updateFactorSetup(id, payload) {
    return this.httpClient().put(
      `${this.endpoint}factor-setup/${id}/`,
      payload
    );
  }

  /**
   * Deletes the factor setup
   * @param {String} id - The id of the factor setup
   */
  deleteFactorSetup(id) {
    return this.httpClient().delete(`${this.endpoint}factor-setup/${id}/`);
  }

  /**
   * ACTION OUTCOMES
   */

  getActionOutcomes(params) {
    return this.httpClient().get(`${this.endpoint}action-outcomes/paginated`, { params });
  }

  /**
   * Creates the action outcome
   * @param {Object} payload - The payload to create the action outcome.
   */
  createActionOutcome(payload) {
    return this.httpClient().post(`${this.endpoint}action-outcomes/`, payload);
  }

  /**
   * Updates the action outcome
   * @param {String} id - The id of the action outcome
   * @param {Object} payload - The payload to update the action outcome.
   */
  updateActionOutcome(id, payload) {
    return this.httpClient().put(
      `${this.endpoint}action-outcomes/${id}/`,
      payload
    );
  }

  /**
   * Deletes the action outcome
   * @param {String} id - The id of the action outcome
   */
  deleteActionOutcome(id) {
    return this.httpClient().delete(`${this.endpoint}action-outcomes/${id}/`);
  }

  /**
   * CLOSED CASE SETTINGS
   */

  getClosedCaseSettings(params) {
    return this.httpClient().get(`${this.endpoint}closed-case-settings/paginated`, { params });
  }

  /**
   * Creates the closed case settings
   * @param {Object} payload - The payload to create the closed case settings.
   */
  createClosedCaseSettings(payload) {
    return this.httpClient().post(
      `${this.endpoint}closed-case-settings/`,
      payload
    );
  }

  /**
   * Updates the closed case settings
   * @param {String} id - The id of the closed case settings
   * @param {Object} payload - The payload to update the closed case settings.
   */
  updateClosedCaseSettings(id, payload) {
    return this.httpClient().put(
      `${this.endpoint}closed-case-settings/${id}/`,
      payload
    );
  }

  /**
   * Deletes the closed case settings
   * @param {String} id - The id of the closed case settings
   */
  deleteClosedCaseSettings(id) {
    return this.httpClient().delete(
      `${this.endpoint}closed-case-settings/${id}/`
    );
  }
}